import { render, staticRenderFns } from "./DsfrSelect.vue?vue&type=template&id=48443c56&scoped=true&"
import script from "./DsfrSelect.vue?vue&type=script&lang=js&"
export * from "./DsfrSelect.vue?vue&type=script&lang=js&"
import style0 from "./DsfrSelect.vue?vue&type=style&index=0&id=48443c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48443c56",
  null
  
)

export default component.exports